// Modify header & footer pdf
import { useContext } from "react"
import { Card, FooterMenu, HeaderMenu } from "../../../../components"
import { dataAccountLinkPurchase, Render, RenderProvider } from "./utils"
import { ChildItem } from "./components"
import { LinkAccountContext, LinkAccountProvider } from "pages/Setup/contexts"
import { exportPdf } from "utils"
import { PdfLinkAccount } from "../components"
import { exportExcel } from "./utils/functions"

export default function LinkAccountPurchase() {
  return (
    <RenderProvider>
      <LinkAccountProvider>
        <section className="container pt-5  gap-5 flex flex-col">
          <HeaderMenu title="LINK ACCOUNT PURCHASE" />

          <Card>
            <Card.Body>
              <div className="overflow-x-auto">
                <TableContent />
              </div>
            </Card.Body>
          </Card>
          <Footer />
        </section>
      </LinkAccountProvider>
    </RenderProvider>
  )
}

function TableContent() {
  const { render } = useContext(Render)

  if (render) {
    return <ChildItem />
  } else {
    return <div />
  }
}

function Footer(): JSX.Element {

  const { data } = useContext(LinkAccountContext)

  return (
    <FooterMenu
      export={{
        actiontype: "export",
        onClick: () => exportExcel({
          dataHeader: dataAccountLinkPurchase,
          data
        })
      }}
      pdf={{
        actiontype: "pdf",
        onClick: () => {
          exportPdf({
            documentComponent: <PdfLinkAccount
              dataLinkAccount={dataAccountLinkPurchase}
              dataList={data}
              title="Link Account Purchase"
            />,
            fileName: "Link Account Purchase"
          })
        }
      }}
    />
  )
}